import React from 'react';
import Styled from 'styled';
import PropTypes from 'prop-types';

import { Halfpage, ZoznamHalfpageTop } from 'lib/google/dfp/ad-units/halfpage';

import { Site } from 'four-nets/site';
import Avatar from 'four-nets/avatar/avatar';

import defaultStyles from './author-side.scss';
import { StyledBadgeInactive } from './author-side-components/author-name/author-name';
import { FormattedMessage } from 'react-intl';

export interface Props {
    styles: typeof defaultStyles;
    username: string;
}

const AuthorSideExpiredVendor: React.FC<Props> = (props, context) => {
    const { styles, username } = props;
    const site = context && context.site;

    return (
        <div className={styles.authorSide}>
            <Avatar style={{ avatar: styles.avatar }} user={null} />
            <div className={styles.header}>
                <div className={styles.profileSummary}>
                    <h1 className={styles.username}>{username}</h1>
                    <StyledBadgeInactive uppercase={true}>
                        <FormattedMessage id='INACTIVE_USER' />
                    </StyledBadgeInactive>
                </div>
            </div>
            {site && site.isSlovak && site.isWedding ? (
                <ZoznamHalfpageTop
                    sizeMapping={[
                        [[0, 0], []],
                        [
                            [1024, 0],
                            ['fluid', [300, 600], [300, 300]],
                        ],
                    ]}
                />
            ) : (
                <Halfpage
                    sizeMapping={[
                        [[0, 0], []],
                        [
                            [1024, 0],
                            ['fluid', [300, 600], [300, 300]],
                        ],
                    ]}
                    adUnitCode='halfpage-top'
                />
            )}
        </div>
    );
};

AuthorSideExpiredVendor.contextTypes = {
    site: PropTypes.instanceOf(Site),
};

export default Styled(defaultStyles)(AuthorSideExpiredVendor);
